export var IssueTypeEnum;
(function (IssueTypeEnum) {
    IssueTypeEnum["UnansweredQuestion"] = "unanswered_questions";
    IssueTypeEnum["MissingSignatures"] = "missing_signatures";
    IssueTypeEnum["MissingDeficiencyNotesPhotos"] = "missing_deficiency_notes_photos";
    IssueTypeEnum["MissingTimeEntries"] = "missing_time_entries";
    IssueTypeEnum["SeverityDiscrepancy"] = "severity_discrepancy";
    IssueTypeEnum["OutOfSpec"] = "out_of_spec_values";
    IssueTypeEnum["AnalyzeDeficiencyNotes"] = "analyze_deficiency_notes";
    IssueTypeEnum["TimingAudit"] = "inspection_timing_audit";
    IssueTypeEnum["AssetCountChange"] = "asset_count_change";
    IssueTypeEnum["DriftingValuesCheck"] = "drifting_values";
    IssueTypeEnum["UlcReferenceClauseCheck"] = "ulc_reference_clause_check";
    IssueTypeEnum["UnresolvedPriorDeficiencies"] = "unresolved_prior_deficiencies";
    IssueTypeEnum["RecurringDeficiencies"] = "recurring_deficiencies";
    IssueTypeEnum["ProximityCheck"] = "proximity_check";
    IssueTypeEnum["AnalyzeDeficiencyPhotos"] = "analyze_deficiency_photos";
    IssueTypeEnum["SignatureQualityCheck"] = "signature_quality_check";
    IssueTypeEnum["PumpCurveCheck"] = "pump_curve_check";
    IssueTypeEnum["MaterialsServicesIncomplete"] = "materials_services_incomplete";
    IssueTypeEnum["DuplicatePhotoDetected"] = "duplicate_photo_detected";
    IssueTypeEnum["CustomRuleFinding"] = "custom_rule_finding";
})(IssueTypeEnum || (IssueTypeEnum = {}));
export var IssueCategoryEnum;
(function (IssueCategoryEnum) {
    IssueCategoryEnum["UnansweredQuestions"] = "unanswered_questions";
    IssueCategoryEnum["NeedsCorrection"] = "needs_correction";
    IssueCategoryEnum["MissingInformation"] = "missing_information";
    IssueCategoryEnum["HistoricalDifference"] = "historical_difference";
    IssueCategoryEnum["GrammarAndStyle"] = "grammar_and_style";
    IssueCategoryEnum["CustomRuleFinding"] = "custom_rule_finding";
    IssueCategoryEnum["Other"] = "other";
})(IssueCategoryEnum || (IssueCategoryEnum = {}));
export var IssueStatusEnum;
(function (IssueStatusEnum) {
    IssueStatusEnum["Detected"] = "detected";
    IssueStatusEnum["Skipped"] = "skipped";
    IssueStatusEnum["Suggested"] = "suggested";
    IssueStatusEnum["Resolved"] = "resolved";
    IssueStatusEnum["DismissedByTech"] = "dismissed_by_tech";
    IssueStatusEnum["DismissedByBackOffice"] = "dismissed_by_back_office";
    IssueStatusEnum["CorrectionSuggested"] = "correction_suggested";
    // IP-14540: an FYI/informational finding (custom_rule_finding) the engine
    // surfaces as a notification rather than an actionable deficiency. Matches
    // the Rails Issue.statuses[:notification] (= 6).
    IssueStatusEnum["Notification"] = "notification";
})(IssueStatusEnum || (IssueStatusEnum = {}));
export var ModeIA;
(function (ModeIA) {
    ModeIA["Full"] = "full";
    ModeIA["Teaser"] = "teaser";
    ModeIA["Trial"] = "trial";
    ModeIA["ReadOnly"] = "read_only"; // when the inspection id is completed and the user is not allowed to edit the issues
})(ModeIA || (ModeIA = {}));
